import { API_URL } from "env";

async function addFeatureToSubcription(subId: number, featureList : number[]) {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/subscriptions/${subId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                features: featureList,
            }),
        });
        const data = await response.json();
        if (!data) {
            throw new Error(data.message || "Failed to add features to subscription");
        }
        return data || null;
    }
    catch (error) {
        console.error("Error adding features to subscription:", error);
        return null;
    }
}
export default addFeatureToSubcription;